module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: [_vm.$root.isRTL ? 'RLT' : ''],
    attrs: {
      "standalone": ""
    }
  }, [_c('v-navigation-drawer', {
    class: [_vm.$root.device.isTablet ? 'tabletMenu' : '', _vm.$root.isRTL ? 'navigation-drawer--right' : '', 'elevation-10'],
    staticStyle: {
      "padding": "0px",
      "margin": "0px",
      "z-index": "200"
    },
    attrs: {
      "hide-overlay": "",
      "light": ""
    },
    model: {
      value: (_vm.$root.activeSubMenu),
      callback: function($$v) {
        _vm.$root.activeSubMenu = $$v
      },
      expression: "$root.activeSubMenu"
    }
  }, [_c('SubMenu')], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "z-index": "100"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.$root.alert.timeout,
      "top": _vm.$root.alert.isTop
    },
    model: {
      value: (_vm.$root.alert.isShow),
      callback: function($$v) {
        _vm.$root.alert.isShow = $$v
      },
      expression: "$root.alert.isShow"
    }
  }, [_vm._v(_vm._s(_vm.$root.alert.message))]), _vm._v(" "), _c('PopupConfim'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('div', {
    class: ['mobileMenu', _vm.$root.activeMobileMenu ? 'activeMenu' : '']
  }, [_c('SubMenu')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-199b6d12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Layout.vue
// module id = 867
// module chunks = 2